import React, { ReactElement } from 'react';

import Flipper from '~/components/buttons/Flipper';
import COLORS from '~/constants/colors';

import { INPUT_MODES } from '../../../constants/defaults';

interface InputModeFlipperProps {
  inputMode: string;
  onChange: (string) => void;
  answersIncluded: boolean;
}

function InputModeFlipper({
  inputMode,
  onChange,
  answersIncluded,
}: InputModeFlipperProps): ReactElement {
  const indexMap = {
    [INPUT_MODES.key]: 0,
    [INPUT_MODES.jog]: 1,
    [INPUT_MODES.gym]: 2,
  };
  const idx = indexMap[inputMode];
  const labels = ['⌨️  Mode', '🏃‍♀️ Mode', '🏋️‍♂️ Mode'];
  const handleFlip = () => {
    const inputModes = Object.keys(indexMap);

    onChange(inputModes[(idx + 1) % inputModes.length]);
  };

  // Styling
  const inputModeFlipperStyle = {
    padding: '0.2em',
    cursor: 'pointer',
  };
  const caseStyles = [
    { backgroundColor: COLORS.white },
    { backgroundColor: COLORS.tropicalBlue },
    { backgroundColor: COLORS.fallGreen },
  ];

  return (
    <Flipper
      labels={labels}
      idx={idx}
      callback={handleFlip}
      disabled={!answersIncluded}
      style={inputModeFlipperStyle}
      caseStyles={caseStyles}
    />
  );
}

export default InputModeFlipper;
